<template>
  <div class="edit-button">
    <div class="errorsNotify" v-if="has_validate_errors">
        <v-alert type="error" text>
            {{$t('error')}}: {{viewsError}}
        </v-alert>
    </div>
    <v-alert
      outlined
      :color="$mainColor">
      <h3 class="headline">{{$t('sent-proposal')}}</h3>
      <div v-if="can_send_proposal">{{$t('sent-proposal-description')}}</div>
      <div v-else>{{$t('no-sent-proposal-description')}}</div>
      <v-divider
        class="my-4 info"
        style="opacity: 0.22"
      ></v-divider>
      <v-row
        align="center"
        no-gutters
        class="d-flex justyfy-between flex-wrap">
        <v-spacer></v-spacer>
        <v-col class="shrink">
          <v-btn 
            :color="$mainColor"
            dark
            @click="reloadPdf(GETTERS_DATA_QUIZE)"
          >
            {{$t('SaveButton.download_as_pdf')}}
          </v-btn>
        </v-col>
        <v-col class="shrink" v-if="can_send_proposal">
          <v-btn
            @click="save_proposal(GETTERS_DATA_QUIZE, {proposal_id:$route.params.id, status_slug:'created'})" 
            :color="$mainColor"
            :loading="loaded"
            dark>
            {{$t('sent')}}
          </v-btn>
        </v-col>
      </v-row>
      
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SaveButton',
  props: ['styles'],
  data() {
    return {
      has_validate_errors: false,
      viewsError: '',
      loaded: false,
      can_send_proposal: false
    }
  },

  async beforeMount() {
    this.can_send_proposal = this.GETTERS_CURRENT_USER.id == this.GETTERS_FILES.applicant_id
  },

  methods: {
    ...mapActions(['PROPOSAL_DETAIL_UPDATE', 'UPDATE_REQUEST_STATUS', 'GET_URL_PRD']),

    reloadPdf(data) {
      this.GET_URL_PRD(this.$route.params.id)
    },

    async save_proposal(data, status) {
        this.loaded = true
        this.checkValidate(data)
        
        if (!this.has_validate_errors) {
          data.id = Number(this.$route.params.id);
          this.PROPOSAL_DETAIL_UPDATE(data)
          .then((res) => {
            if(res.data !== undefined &&  res.data.status){
              this.UPDATE_REQUEST_STATUS(status)
              .then((res) => {
              
                if (res.data.hasOwnProperty('error')) {
                  this.loaded = false

                  this.$messageHelper(res.data['error'], 'error', 3000)
                  // this.$emit('switchDialog');
                  // this.$emit('result', {color:'#b83027', type: false});
                } else {
                  this.loaded = false
                  this.$emit('switchDialog');
                  this.$emit('result', {color:'#4caf50', type: true});
                }
                
              })
              .catch(e => {
                this.loaded = false
                this.$emit('result', {color:'#b83027', type: false});
              })
            }
            else{
              this.loaded = false
              this.$emit('result', {color:'#b83027', type: false});
            }

          })
          .catch(e => {
            this.loaded = false
            this.$emit('result', {color:'#b83027', type: false});
          })
        }
        else{
          this.loaded = false
        }
    },
    saveInfo() {
      this.$emit('saveInfo');
    },
    checkValidate(data) {
      var has_errors = false

      Object.entries(this.GETTERS_NEW_PROPOSAL_STEPPER_CHECK_STATUS).forEach(([step, val]) => {
        if(!val)
          has_errors = true
      })
      if(has_errors){
        this.viewsError = this.$t('SaveButton.error_check_input')
        this.has_validate_errors = true
      }
      else{
        this.has_validate_errors = false
      }


    },
  },
  computed: {
    ...mapGetters([
      'GETTERS_DATA_QUIZE', 
      'GETTERS_NEW_PROPOSAL_STEPPER_CHECK_STATUS',
      'GETTERS_CURRENT_USER',
      'GETTERS_FILES',
    ])
  },
};
</script>

<style scoped>
  .errorsNotify {
    width: 100%;
    margin: 0 auto;
  }
  .errorsNotify__error {
    color: red;
  }
  .btn-save{
    max-width: 350px;
    width: 100%;
    margin: 0 auto;
    background: rgb(22, 51, 110);
    border-radius: 10px;
    color:white;
    padding: 15px 50px;
  }
  .btn-save:hover{
    cursor: pointer;
    background: rgb(22, 51, 110);
  }
  .edit-button {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .btn-save-completed{
    background: rgb(22, 51, 110);
    border-radius: 15px;
    color:white;
    padding: 15px 20px;
  }
  .shrink {
    margin-left: 10px;
  }
</style>
